Vue.asyncComponent('cms-dashboard-image-alt-tags-check', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        statusTone: {
            type: String,
            default: 'success',
        },
        checks: {
            type: Array,
            default: () => [],
        },
        checksCount: {
            type: Number,
            default: 0,
        },
        failedCheckCount: {
            type: Number,
            default: 0,
        },
        pagesScanned: {
            type: Number,
            default: 0,
        },
        pagesWithMissingAltCount: {
            type: Number,
            default: 0,
        },
        missingAltCount: {
            type: Number,
            default: 0,
        },
        widgetCallbackStatuses: {
            type: Object,
            default: () => ({
                loading: false,
                success: null,
                failure: false,
            }),
        },
    },
    methods: {
        /**
         * Trigger a retry callback on the backend.
         *
         * @return {void}
         */
        onRetryClick() {
            this.$emit('retry');
        },
    },
    created() {
        this.$on('refresh', () => {
            this.$root.$emit('cms-dashboard-refresh');
        });
    },
}, 'cms/dashboard/live/cms-dashboard-image-alt-tags-check.html');
